/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { TextButton, ButtonGroup } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import FocusTrap from 'focus-trap-react';
import {
  BodyText,
  BodyTextContainer,
  CloseButton,
  Heading,
  ModalContainer,
  ModalContent,
} from './style';
import mapContext from '../../../contexts/map-context';
import { setFavoritePartner } from '../../../api';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import { ctaBarButtonConfigProps } from '../PartnerBusinessCard/pbc-types';
import { messages } from '../../../i18n/messages';
import CloseIconLarge from '../../common/Icons/CloseIconLarge';

interface Props {
  ctaBarButtonConfig: ctaBarButtonConfigProps[];
}

const MyAudiModal: React.FC<Props> = ({ ctaBarButtonConfig }) => {
  const { clickHandler } = ctaBarButtonConfig[0];
  const dispatch = mapContext.useMapDispatch();
  const [loading, setLoading] = React.useState(false);
  const { favoritePartner, selectedPartner, selectedDealerId } = mapContext.useMapState();

  const closeModal = () => {
    dispatch({
      type: ActionTypes.setShowModal,
      payload: false,
    });
  };

  const handleEscapeKey = () => {
    closeModal();
  };

  const { locale, accessToken: authService } = mapContext.useMapState();

  const setPartner = async (event: any) => {
    setLoading(true);

    try {
      const favorite = await setFavoritePartner(
        authService,
        locale,
        selectedPartner?.kvpsid,
        selectedPartner?.tenant,
      );
      const hasError = Object.prototype.hasOwnProperty.call(favorite, 'message');

      if (hasError) {
        dispatch({
          type: ActionTypes.setErrorMessage,
          payload: { code: favorite?.code, message: favorite?.message },
        });
        setLoading(false);
      } else {
        dispatch({
          type: ActionTypes.setFavoritePartner,
          payload: favorite,
        });
        if (clickHandler) {
          clickHandler(event, selectedDealerId as string);
          closeModal();
          setLoading(false);
        }
      }
    } catch {
      // Error handling - could be logged to service in production
    }
  };

  const heading = useI18n(
    favoritePartner ? messages.myAudiModalChangeHeadline : messages.myAudiModalSetHeadline,
  );

  const copyText1 = useI18n(
    favoritePartner ? messages.myAudiModalChangeCopyText1 : messages.myAudiModalSetCopyText1,
  );

  const copyText2 = useI18n(
    favoritePartner ? messages.myAudiModalChangeCopyText2 : messages.myAudiModalSetCopyText2,
  );

  const setPartnerCta = useI18n(
    favoritePartner ? messages.myAudiModalChangeCta : messages.myAudiModalSetCta,
  );

  const notSetParnterCta = useI18n(
    favoritePartner ? messages.myAudiModalNotChangeCta : messages.myAudiModalNotSetCta,
  );

  return (
    <ModalContainer>
      <FocusTrap
        active
        focusTrapOptions={{
          initialFocus: false,
          returnFocusOnDeactivate: true,
          escapeDeactivates: handleEscapeKey,
          allowOutsideClick: true,
        }}
      >
        <ModalContent>
          <CloseButton onClick={closeModal}>
            <CloseIconLarge />
          </CloseButton>
          <Heading tag="span" variant={{ order: '2', type: 'headline', weight: 'normal' }}>
            {heading}
          </Heading>
          <BodyTextContainer>
            <BodyText
              variant={{
                order: '1',
                style: 'normal',
                type: 'copy',
              }}
            >
              {copyText1}
            </BodyText>
            <BodyText
              variant={{
                order: '1',
                style: 'normal',
                type: 'copy',
              }}
            >
              {copyText2}
            </BodyText>
          </BodyTextContainer>
          <ButtonGroup>
            <TextButton variant="primary" isLoading={loading} onClick={(e) => setPartner(e)}>
              {setPartnerCta}
            </TextButton>
            <TextButton
              variant="secondary"
              onClick={(e) => clickHandler && clickHandler(e, selectedDealerId as string)}
            >
              {notSetParnterCta}
            </TextButton>
          </ButtonGroup>
        </ModalContent>
      </FocusTrap>
    </ModalContainer>
  );
};

export default MyAudiModal;
